import { getPeriodDateRangeValues } from '@/core/ui/PeriodDateRange';
import { convertToDateRange } from './convertToDateRange';
export const getDatesFromStoredValue = (value) => {
    if (value.period === 'custom') {
        return convertToDateRange(value);
    }
    return convertToDateRange(getPeriodDateRangeValues(value.period));
};
